import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";
import styles from "./style.module.scss";

export default function WhyUs() {
  const { greekLicense } = useStaticQuery(graphql`
    query {
      greekLicense: contentfulAsset(
        contentful_id: { eq: "2NIccK5tYDF8JehBVvSs7o" }
      ) {
        fluid(maxHeight: 200) {
          ...GatsbyContentfulFluid_withWebp
        }
      }
    }
  `);

  return (
    <div className={styles.container}>
      <h2>So, why us?</h2>
      <div className={styles.divider} />
      <div className={styles.grid}>
        <div className={styles.grid}>
          <div className={styles.item}>
            <h3>90+ printable products</h3>
            <p>
              Skilled in customizing all promotional products, including
              apparel, accessories, and collectables.
            </p>
          </div>
          <div className={styles.item}>
            <h3>100% love it</h3>
            <p>
              Work with top apparel gurus and designers to create items you
              love.
            </p>
          </div>
          <div className={styles.item}>
            <h3>10,000+</h3>
            <p>
              We've produced over 10,000 custom garments for organizations,
              clubs, and events.
            </p>
          </div>
          <div className={styles.item}>
            <h3>Seamless</h3>
            <p>
              We seamlessly integrate with your organization to make the
              ordering process simple.
            </p>
          </div>
        </div>
        <div>
          <Img
            className={styles.image}
            fluid={greekLicense.fluid}
            alt="Official Greek Licensed Product"
          />
        </div>
      </div>
    </div>
  );
}
